import * as Yup from 'yup';
import { isFuture } from 'date-fns';
import { isNull } from 'lodash';
import accidentAddressSchema from '../accidentAddressSchema';

const accidentInfoSchema = Yup.object().shape({
  contract: Yup.object()
    .nullable()
    .required('validationErrors.isRequired'),
  accidentDate: Yup.date()
    .nullable()
    .test(
      'accidentDate',
      'validationErrors.accDateCantBeFuture',
      (value) => !isFuture(value),
    )
    .when(
      'startDate',
      (startDate, schem) => startDate && schem.min(startDate, 'validationErrors.notStartedPolicy'),
    )
    .when(
      'endDate',
      (endDate, schem) => endDate && schem.max(endDate, 'validationErrors.expiredPolicy'),
    )
    .required('validationErrors.isRequired'),
  accidentTime: Yup.string()
    .nullable()
    .required('validationErrors.isRequired'),
  carCountry: Yup.object()
    .nullable()
    .when('damageLevel', {
      is: (damageLevel) => damageLevel === 1,
      then: Yup.object().required('validationErrors.isRequired'),
    }),
  carState: Yup.object()
    .nullable()
    .when('isCarInArmenia', {
      is: true,
      then: Yup.object().required('validationErrors.isRequired'),
    }),
  carVillage: Yup.object()
    .nullable()
    .when(['carCountry', 'carState'], (carCountry, carState, schema) => {
      if (carCountry && carCountry.label === 'ARM' && (!isNull(carState) && carState.label !== 'YR')) {
        return schema.required('validationErrors.isRequired');
      }
      if (carCountry && carCountry.label === 'ARM' && isNull(carState)) {
        return schema.required('validationErrors.isRequired');
      }
      return schema;
    }),
  carStreet: Yup.string()
    .nullable()
    .when('damageLevel', {
      is: (damageLevel) => damageLevel === 1,
      then: Yup.string()
        .required('validationErrors.isRequired')
        .isCorrectLanguage(),
    }),
  damageAmount: Yup.number()
    .nullable()
    .typeError('validationErrors.onlyNumber')
    .max(200000000, 'validationErrors.maxNumber')
    .test('isZero', 'validationErrors.isRequired', (v) => v !== 0)
    .required('validationErrors.isRequired'),
  damagedParts: Yup.string()
    .nullable()
    .max(1000, 'validationErrors.maxNumber')
    .isCorrectLanguage()
    .required('validationErrors.isRequired'),
  accidentDetails: Yup.string()
    .nullable()
    .max(1000, 'validationErrors.maxNumber')
    .isCorrectLanguage()
    .required('validationErrors.isRequired'),
  proceedingStatus: Yup.string()
    .nullable()
    .required('validationErrors.isRequired'),
}).concat(accidentAddressSchema);

export default accidentInfoSchema;

export const getRowSchema = (id) => Yup.object().shape({
  [`stateNumber_${id}`]: Yup.string()
    .when('isExistOtherCar', {
      is: (isExistOtherCar) => isExistOtherCar,
      then: Yup.string()
        .min(3, 'searchApplicantErrors.passportNumMin')
        .required('validationErrors.isRequired'),
    }),
});
